import React, { useState } from 'react';
import Overview from './Overview';
import Content from './Content';
import Instructors from './Instructors';
import Reviews from './Reviews';

const CourseTabs = ({ course }) => {
   const [activeTab, setActiveTab] = useState('overview');

   const tabs = [
      { id: 'overview', label: 'Description' },
      { id: 'modules', label: 'Modules' },
      { id: 'instructeur', label: 'Instructeur' },
      { id: 'avis', label: 'Avis' }
   ];

   return (
      <section className="pt-12 pb-8 dark:bg-dark-2">
         <div className="container mx-auto px-4">
            <div className="flex flex-wrap -mx-4">
               <div className="w-8/12 px-4">
                  <div className="pt-8 pb-8 px-8 bg-white">
                     {/* Onglets */}
                     <div className="flex border-b border-gray-200 dark:border-gray-700">
                        {tabs.map(tab => (
                           <button
                              key={tab.id}
                              className={`pb-4 px-4 font-medium ${activeTab === tab.id ? 'text-purple-1 \
                                 dark:text-purple-1 border-b-2 border-purple-1 dark:border-purple-1' :
                                 'text-gray-600 dark:text-gray-400'}`}
                              onClick={() => setActiveTab(tab.id)}
                           >
                              {tab.label}
                           </button>
                        ))}
                     </div>

                     {/* Contenu des onglets */}
                     <div className="pt-12">
                        {activeTab === 'overview' && (
                           <Overview course={course} />
                        )}
                        {activeTab === 'modules' && (
                           <Content course={course} />
                        )}
                        {activeTab === 'instructeur' && (
                           <Instructors course={course} />
                        )}
                        {activeTab === 'avis' && (
                           <Reviews course={course} />
                        )}
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
};

export default CourseTabs;